











import Vue from "vue";
import Resume from "./views/Resume.vue";
import Slider from "./components/Slider.vue";

export default Vue.extend({
  name: "App",
  components: {
    Resume,
    Slider,
  },

  data: () => ({
    //
  }),
  computed: {
    appBack() {
      return this.$store.state.appBack;
    },
  },
});
